module.exports = __webpack_public_path__ + "static/Nicola-e69ddef5c1f0ba72a75ce802366ed543.png";